import { useAtomValue } from 'jotai'
import { enabledUseCasesAtom } from '../state/useCasesAtom'
import { useFetchLayerSuitability } from '../../suitability/hooks/useFetchLayerSuitability'

export const useAvailableUseCases = (layerId: string) => {
  const enabledUseCases = useAtomValue(enabledUseCasesAtom)
  const { data: suitabilities = [] } = useFetchLayerSuitability(layerId)

  return enabledUseCases.filter((uc) => !suitabilities.some((s) => s.use_case_slug === uc.slug))
}
